// react
import { useContext, useEffect, useState } from "react";

// context
import ProductContext from "../../context/ProductContext";

// components
import { Heading } from "../heading/Heading";

// styles
import "./pdpLink.styles.scss";

const PdpLink = () => {
  const context: any = useContext(ProductContext);

  const {
    productState: { ProductUrl, ProductNumber },
  }: {
    productState: {
      ProductUrl: string;
      ProductNumber: string;
    };
  } = context;

  const [localProductNumber, setProductNumber] = useState(ProductNumber);

  useEffect(() => {
    setProductNumber(ProductNumber);
  }, [ProductNumber]);

  return (
    <>
      {localProductNumber && (
        <div className={"pricingAvailability_title"}>
          <Heading
            className={
              "pricingAvailability_title_lineBreak hdg hdg_h3 hdg_neutral pd_8"
            }
            element="h3"
          >
            {localProductNumber.toUpperCase()}
          </Heading>
          {ProductUrl ? (
            <a className={"pdp-link"} href={ProductUrl}>
              GO TO PRODUCT
              <span className={"pdp-link__chevron_container"}>
                <svg
                  width="18"
                  height="14"
                  viewBox="0 0 18 14"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <g fill="none" fill-rule="evenodd">
                    <rect width="18" height="14"></rect>
                    <path
                      d="M5.32138771,12.0187784 C4.88750173,12.4774933 4.89370691,13.2066434 5.33533425,13.6575897 C5.77696159,14.108536 6.49104363,14.1148721 6.94027894,13.6718306 L12.6647882,7.82652606 C13.1117373,7.37000795 13.1117373,6.62999205 12.6647882,6.17347394 L6.94027894,0.328169447 C6.49104363,-0.114872145 5.77696159,-0.108536027 5.33533425,0.342410275 C4.89370691,0.793356576 4.88750173,1.52250674 5.32138771,1.98122156 L10.2364514,7 L5.32138771,12.0187784 Z"
                      className={"pdp-link__chevron_container__chevron"}
                    ></path>
                  </g>
                </svg>
              </span>
            </a>
          ) : (
            <span className={"pdp-link"}>GO TO PRODUCT</span>
          )}
        </div>
      )}
    </>
  );
};

export default PdpLink;
